module.exports = __webpack_public_path__ + "img/product_86.5df14e2.webp";